import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Contact, ContactImportResponse, ContactPayload } from '../models/api.models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ContactsService {
  constructor(private readonly api: ApiService) {}

  list(): Observable<Contact[]> {
    return this.api.get<Contact[]>('/contacts');
  }

  create(payload: ContactPayload): Observable<Contact> {
    return this.api.post<Contact>('/contacts', payload);
  }

  import(payload: { contacts: ContactPayload[] }): Observable<ContactImportResponse> {
    return this.api.post<ContactImportResponse>('/contacts/import', payload);
  }

  update(contactId: number, payload: ContactPayload): Observable<Contact> {
    return this.api.put<Contact>(`/contacts/${contactId}`, payload);
  }

  delete(contactId: number): Observable<{ message: string }> {
    return this.api.delete<{ message: string }>(`/contacts/${contactId}`);
  }
}
